import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable({providedIn: 'root'})
export class AuthService {
    
    constructor(private http: HttpClient) {

    }
    
    login(data): Observable<any> {
        return this.http.post<any>(`${environment.baseUrl}/login`, data)
        .pipe(
            map( res => res)
        )
    }

    checkUserAvailability(data): Observable<any> {
        return this.http.post<any>(`${environment.baseUrl}/check-user-availability`, data)
        .pipe(
            map( res => res)
        )
    }

    checkSecurityQuestins(data): Observable<any> {
        return this.http.post<any>(`${environment.baseUrl}/check-security-question`, data)
        .pipe(
            map( res => res)
        )
    }

    changePassword(data): Observable<any> {
        return this.http.post<any>(`${environment.baseUrl}/forgot-password`, data)
        .pipe(
            map( res => res)
        )
    }

}